export default theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.5)
  },
  rootDisabled: {
    backgroundColor: theme.palette.common.muted,
    padding: theme.spacing(0.5)
  },
  dragging: {
    backgroundColor: theme.palette.primary.selected,
    maxWidth: '82%'
  },
  stopHeader: {
    display: 'flex',
  },
  headerSection: {
    flexBasis: '18.5%',
    flexShrink: 0,
    overflowX: 'hidden'
  },
  headerSectionSmall: {
    flexBasis: '16%',
    flexShrink: 0,
    overflowX: 'hidden'
  },
  headerSectionLarge: {
    flexBasis: '24.5%',
    flexShrink: 0,
    overflowX: 'hidden'
  },
  lastHeaderSection: {
    flexBasis: '16%',
  },
  wrapper: {
    display: 'flex',
    margin: theme.spacing(2)
  },
  wrapperChild: {
    flex: 1,
  },
  iconButton: {
    padding: '0'
  }
});

